/* eslint-disable no-sequences */
import axios from "axios";
import { apiUrl_forCart } from "./constants";

const CancelToken = axios.CancelToken;

// get cart
export let cancelGetCartTempApi;
export async function getCartByTemp(headers, temp_order_id) {
    if (headers && temp_order_id) {
        const cart = await axios.get(
            apiUrl_forCart + "?temp_order_id=" + temp_order_id,
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    cancelGetCartTempApi = c;
                }),
            }
        );
        return cart;
    } else {
        console.log("Please add required parameters");
    }
}

// get cart
// export let cancelGetCartApi;
// export async function getCart(headers, store_id, cart_id) {
//     if (headers) {
//         const cart = await axios.get(
//             apiUrl_forCart + "?store_id=" + store_id + "&cart_id=" + cart_id,
//             {
//                 headers: { ...headers },
//                 cancelToken: new CancelToken(function executor(c) {
//                     cancelGetCartApi = c;
//                 }),
//             }
//         );
//         return cart;
//     } else {
//         console.log("Please add required parameters");
//     }
// }

// add cart
export let cancelAddCartApi;
export async function addCart(headers, cartData) {
    if ((headers && cartData)) {
        const cart = await axios.put(
            apiUrl_forCart,
            cartData,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelAddCartApi = c;
                }),
            }
        );
        return cart;
    } else {
        console.log("Please add required parameters");
    }
}

// update customer
export let cancelEditCartApi;
export async function editCustomer(headers, cartData) {
    if ((headers && cartData)) {
        const cart = await axios.put(
            apiUrl_forCart + cartData.user_id,
            cartData,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelEditCartApi = c;
                }),
            }
        );
        return cart;
    } else {
        console.log("Please add required parameters");
    }
}

// delete delete cart
export let cancelDeleteCartApi;
export async function deleteCart(headers, cart_id, token_id) {
    if ((headers && cart_id && token_id)) {
        const cart = await axios.delete(
            apiUrl_forCart + cart_id + "/" + token_id,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelDeleteCartApi = c;
                }),
            }
        );
        return cart;
    } else {
        console.log("Please add required parameters");
    }
}

// empty cart
// export let cancelEmptyCartApi;
// export async function emptyCart(token, temp_order_id) {
//     if ((token && temp_order_id)) {
//         const cart = await axios.delete(
//             apiUrl_forCart + "empty/" + temp_order_id,
//             {
//                 headers: { ...headers },
//             },
//             {
//                 cancelToken: new CancelToken(function executor(c) {
//                     cancelDeleteCartApi = c;
//                 }),
//             }
//         );
//         return cart;
//     } else {
//         console.log("Please add required parameters");
//     }
// }

// get cart item
export let cancelGetCartItemsWithOrderIdApi;
export async function getCartItemsWithOrderId(headers, tempOrderId) {
    if (headers && tempOrderId) {
        const cartData = await axios.get(
            apiUrl_forCart + "?temp_order_id=" + tempOrderId,
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetCartItemsWithOrderIdApi = c;
                }),
            }
        );
        return cartData;
    } else {
        console.log("Please add required parameters");
    }
}

// charge order payment
export let cancelChargeOrderPaymentApi;
export async function chargeOrderPaymentApi(headers, { order_id, stripe_token }) {
    if (headers && order_id && stripe_token) {
        const cart = await axios.put(
            apiUrl_forCart + "charge/payment/" + order_id,
            { stripe_token },
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelChargeOrderPaymentApi = c;
                }),
            }
        );
        return cart;
    } else {
        console.log("Please add required parameters");
    }
}

// send payment link
export let cancelSendPaymentLinkApi;
export async function sendPaymentLinkApi(headers, { order_id, message }) {
    if (headers && order_id) {
        const cart = await axios.put(
            apiUrl_forCart + "send/payment/" + order_id,
            { message },
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelSendPaymentLinkApi = c;
                }),
            }
        );
        return cart;
    } else {
        console.log("Please add required parameters");
    }
}
